import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=483d923b&lang=scss&scoped=true"
script.__scopeId = "data-v-483d923b"

export default script